<template>
  <div style="padding-top: 1rem">
    <json-editor-vue
      v-model="localValue"
      :mode="'text'"
      @update:model-value="(data) => updateData(data)"
    ></json-editor-vue>
  </div>
</template>

<script>
import { ref, watch } from 'vue';
import JsonEditorVue from 'json-editor-vue';

export default {
  components: {
    JsonEditorVue,
  },
  props: {
    attribute: { type: String, default: null },
    name: { type: String, default: '' },
    readonly: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    errors: { type: Array, default: null },
    value: { type: [Array, Object, String], default: () => null },
    label: { type: String, default: '' },
    rows: { type: Number, default: 1 },
  },
  emits: ['update:data'],
  setup(props, { emit }) {
    const localValue = ref(props.value);

    const updateData = (data) => {
      if (typeof data === 'string') {
        try {
          data = JSON.parse(data);
        } catch (e) {
          // console.log(e);
        }
      }
      emit('update:data', data);
    };

    watch(
      () => props.value,
      (updatedValue) => {
        localValue.value = updatedValue;
      }
    );

    return {
      localValue,
      updateData,
    };
  },
};
</script>

<style lang="scss">
.forgeron-content-container .form-floating label.jse-hidden-input-label {
  padding: 0 !important;
}

:root {
  --jse-theme-color: var(--primary-color) !important;
}
</style>
